// extracted by mini-css-extract-plugin
export default {"nameDobContainer":"_name-date-of-birth-login_nameDobContainer__Bjl5T","inputCol":"_name-date-of-birth-login_inputCol__Y2JAz"};